import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Select,
  MenuItem,
  createStyles,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import * as types from '../../../actions/actionTypes';
import KeyboardControls from '../../utility/KeyboardControls';
import { locations } from '../../../lib/constants';
import { isMobile } from '../../../lib/getDeviceSize';
import { priceRange } from '../search/constants';
import NumberElement from '../../utility/NumberElement';
import { media } from '../../../styles/base';

interface Props {
  classes: any;
  dispatch: any;
  open: boolean;
  handleClose: Function;
  handleSubmit: Function;
}

const styles = createStyles({
  actionButtons: {
    backgroundColor: '#F9F9F9',
    borderTop: '1px solid #BDBDBD',
    display: 'flex',
    justifyContent: 'space-between',
    padding: isMobile() ? '8px 10px' : '12px 38px',
  },
  canceButton: {
    color: '#323232',
    fontSize: 16,
    fontWeight: 'bold',
    letterSpacing: 1.25,
  },
  contentStyle: {
    margin: '0 auto',
  },
  controlsBullet: {
    backgroundColor: 'black',
    borderRadius: '50%',
    height: 5,
    marginRight: 15,
    width: 5,
  },
  controlsRow: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    margin: 5,
  },
  formField: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 35,
  },
  leftDot: {
    backgroundColor: '#eb6565',
    borderRadius: '50%',
    height: 10,
    marginRight: 15,
    width: 10,
  },
  mobileImageStyle: {
    alignItems: 'center',
    display: 'flex',
    margin: '0 auto',
    marginTop: 25,
  },
  paper: {
    borderRadius: 15,
    display: 'flex',
    justifyContent: 'center',
    maxHeight: 680,
    minHeight: 550,
    minWidth: 640,
    padding: 0,
    [media.mobile]: {
      borderRadius: 10,
      margin: '25px 13px',
      maxHeight: '93%',
      maxWidth: '94%',
      minWidth: '94%',
    },
  },
  rightDot: {
    backgroundColor: '#eb6565',
    borderRadius: '50%',
    height: 10,
    marginLeft: 15,
    width: 10,
  },
  submitButton: {
    backgroundColor: '#463264',
    borderRadius: 3,
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: 'bold',
    height: 40,
    letterSpacing: 1.25,
    width: 155,
  },
  subTitleText: {
    textAlign: 'center',
  },
  title: {
    alignItems: 'center',
    color: '#323232',
    display: 'flex',
    flexDirection: 'row',
    fontSize: 36,
    justifyContent: 'center',
    paddingBottom: 0,
  },
});

const DEFAULT_LOCATION = 'MA';
const DEFAULT_MAX_PRICE = 800000;

export function RandomForm(props: Props) {
  const [location, setLocation] = useState(DEFAULT_LOCATION);
  const [maxPrice, setMaxPrice] = useState(DEFAULT_MAX_PRICE);

  const handleClose = () => {
    props.handleClose();
  };

  const handleFormSubmit = () => {
    props.dispatch({
      location,
      maxPrice,
      type: types.StoreRandomHomePreferences,
    });
    props.handleSubmit(maxPrice, location);
    handleClose();
  };

  const { classes, dispatch } = props;
  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      classes={{ paper: classes.paper }}
    >
      <DialogTitle classes={{ root: classes.title }} disableTypography>
        <div className={classes.leftDot} />
        Random Home
        <div className={classes.rightDot} />
      </DialogTitle>
      <DialogContent classes={{ root: classes.contentStyle }}>
        <Typography className={classes.subTitleText}>
          Choose a location and price and swipe through random homes for sale
        </Typography>
        <div className={classes.formField}>
          <Typography>Location</Typography>
          <Select
            value={location}
            onChange={(event: any) => setLocation(event.target.value)}
            placeholder="Location"
            style={{ width: 200 }}
            MenuProps={{
              anchorOrigin: {
                horizontal: 'left',
                vertical: 'bottom',
              },
              getContentAnchorEl: null,
            }}
          >
            {Object.keys(locations).map((locationItem: any) => {
              return (
                <MenuItem key={locationItem} value={locationItem}>
                  {locations[locationItem]}
                </MenuItem>
              );
            })}
          </Select>
        </div>
        <div className={classes.formField}>
          <Typography>Price</Typography>
          <Select
            value={maxPrice}
            onChange={(event: any) => setMaxPrice(event.target.value)}
            placeholder="Max price"
            style={{ width: 200 }}
          >
            {priceRange.map((price: any, index: number) => {
              return (
                <MenuItem key={index} value={price}>
                  <NumberElement val={price} prefix={'$'} decimalScale={0} />
                </MenuItem>
              );
            })}
          </Select>
        </div>
        <KeyboardControls handleClose={handleClose} padTop />
      </DialogContent>
      <DialogActions classes={{ root: classes.actionButtons }} style={{}}>
        <Button onClick={handleClose} classes={{ root: classes.canceButton }}>
          CANCEL
        </Button>
        <Button
          color="primary"
          onClick={handleFormSubmit}
          classes={{ root: classes.submitButton }}
          variant="contained"
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default withStyles(styles)(RandomForm);
